import Vue from 'vue'

let vm=new Vue({});

const beforeClose = {
  before_close_normal: (resolve:any) => {
    vm.$Modal.confirm({
      title: '确定要关闭这一页吗',
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  }
}

export default beforeClose
